/* ============================================================
   sm-hurda-guard.js

   Stoðvar pöntun á nafnaskilti sem ber ekkert nafn.

   Mælt 2026-09-22 á /products/hurdaskilti-akryl: með nafnareitinn
   tóman var körfuhnappurinn fullvirkur (disabled false, opacity 1),
   engin viðvörun birtist, og beiðnin fór af stað:

     POST /cart/add.js
     {"id":42053902041173,"quantity":1,"properties":{
       "Efni og litur":"Akrýl silvur","Stærð":"7,5 × 12 cm",
       "Form":"Ferhyrnt","Rammi":"Með ramma","Leturgerð":"Nútímalegt"}}

   Takið eftir að eiginleikinn "Nöfn" er EKKI í beiðninni. Pöntunin
   hefði því borist verkstæðinu með öllu nema því eina sem á að standa
   á skiltinu. Slíka pöntun er ekki hægt að afgreiða.

   AÐFERÐIN: hlustað er í griplufasa (capture), bæði á submit á forminu
   og á smell á körfuhnappinn. Griplufasi keyrir ALLTAF á undan
   loftbólufasa, óháð því í hvaða röð hlustendur voru skráðir, svo þetta
   kemst að á undan sm-hurda-config.js hvort sem það skráir sig fyrr eða
   seinna. stopImmediatePropagation stöðvar líka aðra hlustendur á sama
   staki.

   Hnappurinn er EKKI gerður óvirkur. Óvirkur hnappur segir ekki af
   hverju hann er óvirkur. Í staðinn fær notandinn skýra ástæðu, bendingu
   um hvað þarf að gera, og bendillinn fer í reitinn.

   TÓMT HEIMILISFANG (bætt við 2026-09-26). Sama gat, önnur lína: með
   hakað við Heimilisfang en reitinn tóman fór já-afbrigðið í körfu án
   eiginleikans "Heimilisfang", t.d. "Hvítt / 5 × 12 cm (1-2 nöfn) / já"
   með Nöfnum en engu heimilisfangi (mælt á öllum fjórum hurðaskiltunum).
   Á gömlu síðunni er reiturinn skyldureitur um leið og já er valið
   (Easify 375316, "Heimilisfang" req=1). Nú er það stöðvað eins og tóm
   nöfn: skilaboð beint undir reitnum, bendillinn þangað, engin beiðni.
   Í símahamnum fer reiturinn í augsýn í stað fókuss, sjá iSjonmali.
   Hakið sjálft ræður, því það velur já-afbrigðið í sm-hurda-config.js.
   Séu bæði nöfn og heimilisfang tóm birtast bæði skilaboðin og bendillinn
   fer í efri reitinn, heimilisfangið.

   Í síma bætir sm-hurda-steps.js við eigin körfuhnappi neðst (stikan með
   [data-order-summary]). Hann sendir submit á formið og segir svo
   "Bætt í körfu" eftir 700 ms hvort sem eitthvað fór í körfu eða ekki.
   Tóm nöfn ná aldrei þangað, því sá hnappur er óvirkur án nafna, en tómt
   heimilisfang gerði það. Því er smellur á hann líka gripinn hér, í
   griplufasa á document, áður en hann kemst að hnappnum sjálfum.
   ============================================================ */
(function () {
  var SKILABOD = 'Skrifaðu nafnið sem á að standa á skiltinu áður en þú setur það í körfu.';

  function reitur() {
    return document.querySelector('.pdp-hurda [data-names]');
  }

  function tomur() {
    var t = reitur();
    return !t || t.value.replace(/\s+/g, '') === '';
  }

  function vidvorun(syna) {
    var w = document.querySelector('.pdp-hurda [data-warn]');
    if (!w) return;
    if (syna) {
      /* role=alert svo skjálesari lesi hana upp þegar hún birtist */
      w.setAttribute('role', 'alert');
      w.textContent = SKILABOD;
      w.hidden = false;
    } else if (w.getAttribute('data-sm-guard') === '1') {
      w.hidden = true;
      w.textContent = '';
    }
    w.setAttribute('data-sm-guard', syna ? '1' : '0');
  }

  var SKILABOD_HEIMILISFANG = 'Skrifaðu heimilisfangið eða íbúðarnúmerið sem á að standa efst á skiltinu, eða taktu hakið af „Heimilisfang“.';

  function heimilisfangReitur() {
    return document.querySelector('.pdp-hurda [data-address]');
  }

  /* Hakið er til tvisvar (á forskoðuninni og í skrefi 1) og
     sm-hurda-config.js heldur þeim samstilltum með klasanum "on". */
  function hakadVidHeimilisfang() {
    var hak = document.querySelector('.pdp-hurda [data-toggle-addr]');
    return !!hak && (hak.classList.contains('on') || hak.getAttribute('aria-pressed') === 'true');
  }

  function heimilisfangTomt() {
    var a = heimilisfangReitur();
    return hakadVidHeimilisfang() && !!a && a.value.replace(/\s+/g, '') === '';
  }

  /* Skilaboðin fara beint á eftir reitnum, inni í [data-addr-field], svo
     þau hverfa með reitnum þegar hakið er tekið af. */
  function heimilisfangVidvorun(syna) {
    var a = heimilisfangReitur();
    if (!a) return;
    var w = document.querySelector('.pdp-hurda [data-addr-warn]');
    if (!w) {
      if (!syna) return;
      w = document.createElement('div');
      w.className = 'txt-warn';
      w.id = 'sm-hurda-addr-warn';
      w.setAttribute('data-addr-warn', '');
      /* Reiturinn liggur þétt ofan á nafnareitnum; bil svo kassinn klessist ekki við hann */
      w.style.marginBottom = '8px';
      w.hidden = true;
      a.parentNode.insertBefore(w, a.nextSibling);
    }
    if (syna) {
      w.setAttribute('role', 'alert');
      w.textContent = SKILABOD_HEIMILISFANG;
      w.hidden = false;
      a.setAttribute('aria-invalid', 'true');
      a.setAttribute('aria-describedby', w.id);
    } else {
      w.hidden = true;
      w.textContent = '';
      a.removeAttribute('aria-invalid');
      if (a.getAttribute('aria-describedby') === w.id) a.removeAttribute('aria-describedby');
    }
  }

  function beina(t) {
    if (!t) return;
    try { t.scrollIntoView({block: 'center', behavior: 'smooth'}); } catch (err) { t.scrollIntoView(); }
    t.focus();
  }

  function limt(el) {
    var p = getComputedStyle(el).position;
    return p === 'sticky' || p === 'fixed';
  }

  /* SÍMAHAMUR (reiturinn inni í .hs-namebox, sem sm-hurda-steps.js býr til
     undir 1000px). Þar er forskoðunin (.stage) límd efst og körfustikan
     límd neðst, og sm-hurda-steps.js skrunar síðunni efst í hvert sinn
     sem reitur í .hs-namebox fær fókus eða lyklaborðið breytir skjánum.
     Fókus hér kallaði á það skrun: mælt í 375 × 812 lenti reiturinn á
     741-791 og skilaboðin á 799-854, neðan við skjáinn. Í síma opnar
     fókus líka lyklaborðið, sem kallar aftur á sama skrun. Í staðinn eru
     reiturinn og skilaboðin færð inn á auða svæðið milli forskoðunar og
     stiku, og viðskiptavinurinn pikkar sjálfur í reitinn. Skjálesari fær
     skilaboðin samt strax (role=alert) og reiturinn er merktur ógildur.
     html er með scroll-behavior: smooth, svo það er tekið af á meðan
     mælt er og fært, annars væru mælingarnar teknar í miðju skruni. */
  function iSjonmali(t, w) {
    var html = document.documentElement, fyrra = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    try {
      t.scrollIntoView({block: 'center'});
      var r = t.getBoundingClientRect();
      var nedri = (w && !w.hidden) ? w.getBoundingClientRect().bottom : r.bottom;
      var efst = 0, nedst = window.innerHeight, bil = 12;
      var stage = document.querySelector('.pdp-hurda .stage');
      if (stage && limt(stage)) {
        var s = stage.getBoundingClientRect();
        if (s.left < r.right && s.right > r.left) efst = Math.max(0, s.bottom);
      }
      for (var el = document.querySelector('.pdp-hurda [data-order-summary]'); el && el !== document.body; el = el.parentElement) {
        if (limt(el)) { nedst = Math.min(nedst, el.getBoundingClientRect().top); break; }
      }
      var upp = r.top - (efst + bil);
      var nidur = nedri - (nedst - bil);
      var faera = upp < 0 ? upp : (nidur > 0 ? Math.min(nidur, upp) : 0);
      if (faera) window.scrollBy(0, faera);
    } catch (err) {
      /* eldri vafrar án scrollIntoView-valkosta */
      try { t.scrollIntoView(); } catch (err2) {}
    }
    html.style.scrollBehavior = fyrra;
  }

  function beinaHeimilisfangi() {
    var a = heimilisfangReitur();
    if (!a) return;
    if (a.closest && a.closest('.hs-namebox')) {
      iSjonmali(a, document.querySelector('.pdp-hurda [data-addr-warn]'));
    } else {
      beina(a);
    }
  }

  function vordur(e) {
    var nafnVantar = tomur();
    var heimilisfangVantar = heimilisfangTomt();
    if (!nafnVantar) vidvorun(false);
    if (!heimilisfangVantar) heimilisfangVidvorun(false);
    if (!nafnVantar && !heimilisfangVantar) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (nafnVantar) vidvorun(true);
    if (heimilisfangVantar) heimilisfangVidvorun(true);
    /* Heimilisfangið er efsta línan og reiturinn stendur ofan við nöfnin */
    if (heimilisfangVantar) beinaHeimilisfangi();
    else beina(reitur());
  }

  /* Körfuhnappur símastikunnar: hnappur sem stendur við hlið [data-order-summary] */
  function stikuhnappur(el) {
    var b = el && el.closest ? el.closest('button') : null;
    if (!b || b.type === 'submit' || !b.closest('.pdp-hurda')) return null;
    var p = b.parentNode;
    return p && p.querySelector('[data-order-summary]') ? b : null;
  }

  function setja() {
    var form = document.querySelector('.pdp-hurda form[data-hurda-form]');
    if (!form || form.getAttribute('data-sm-guarded') === '1') return;
    form.setAttribute('data-sm-guarded', '1');

    form.addEventListener('submit', vordur, true);

    var hnappar = form.querySelectorAll('button[type="submit"]');
    for (var i = 0; i < hnappar.length; i++) {
      hnappar[i].addEventListener('click', vordur, true);
    }

    /* Viðvörunin hverfur um leið og eitthvað er skrifað, svo hún hangi
       ekki uppi eftir að búið er að laga það sem hún benti á. */
    var t = reitur();
    if (t) {
      t.addEventListener('input', function () {
        if (!tomur()) vidvorun(false);
      });
    }

    document.addEventListener('click', function (e) {
      if (stikuhnappur(e.target)) vordur(e);
    }, true);

    var a = heimilisfangReitur();
    if (a) {
      a.addEventListener('input', function () {
        if (a.value.replace(/\s+/g, '') !== '') heimilisfangVidvorun(false);
      });
    }
    /* Hak tekið af (eða sett aftur): gömul skilaboð eiga ekki lengur við */
    var hok = document.querySelectorAll('.pdp-hurda [data-toggle-addr]');
    for (var j = 0; j < hok.length; j++) {
      hok[j].addEventListener('click', function () { heimilisfangVidvorun(false); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setja);
  } else {
    setja();
  }
})();
